import { Team } from '@services/Session/team.d';

export enum ImageCategory {
  LOGO = '100',
  COVER = '102',
}

export interface TeamActionButtonsProps {
  teamId: string | undefined;
  onUploadImage: (category: string, url: string) => void;
  setTeamLogoUploading: (uploading: boolean) => void;
}

export interface TeamInfoFormProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedTeam: Team;
  onFormUpdate: (updatedData: FormValues) => void;
}
export interface FormValues {
  nameLong: string;
  nameHandle?: string;
  nameMed?: string;
  nameLocation?: string;
  zipCode?: string;
  attrib_season?: number;
  attrib_sportType?: string;
  attrib_ageLevel?: string;
  socialFacebookUrl?: string;
  socialInstagramHandle?: string;
  socialTwitterHandle?: string;
  colorTeamPrimary?: string;
}

export const defaultFormValues: FormValues = {
  nameLong: '',
  nameHandle: '',
  nameMed: '',
  attrib_sportType: '',
  zipCode: '',
  socialFacebookUrl: '',
  socialInstagramHandle: '',
  socialTwitterHandle: '',
};

export interface TeamArchiveOrDeleteProps {
  canDelete: boolean;
  isTeamRemoved: boolean;
  isTeamRemovalProcessing: boolean;
  onCancel: () => void;
  onArchive: () => void;
  onDelete: () => void;
}
